import React, { FC } from 'react';
import { EditableComponent } from '@adobe/aem-react-editable-components';

import {
  ANCILLARY_PRODUCT_OFFER,
  MULTI_BRAND_MULTI_PROP_OFFER,
  SINGLE_BRAND_MULTI_PROP_OFFER,
  SINGLE_PROPERTY_OFFER,
  COBRAND_SINGLE_OFFER,
} from '../../constants/OffersHeroConstants';

import { OffersHeroSingleProperty } from './OffersHeroSingleProperty';
import { OffersHeroMultiProperty } from './OffersHeroMultiProperty';
import { StyledOffersHero, StyledOffersHeroPreviewMode } from './OffersHero.styles';
import { OfferHeroProps } from './OffersHero.types';

// Use named rather than default exports.
const OffersHeroReactWrapper: FC<OfferHeroProps> = props => {
  const { model, offersData, acceptLanguage, getOfferDataFromLightning, isLogoFlagEnabled } = props;
  const OfferHeroComponent: React.FC = () => {
    switch (model?.variation) {
      case SINGLE_BRAND_MULTI_PROP_OFFER:
        return (
          <OffersHeroMultiProperty
            modelObj={model}
            offersHeroProps={offersData}
            variation={SINGLE_BRAND_MULTI_PROP_OFFER}
            acceptLanguage={acceptLanguage}
            getOfferDataFromLightning={getOfferDataFromLightning}
            isLogoFlagEnabled={isLogoFlagEnabled}
          />
        );
      case COBRAND_SINGLE_OFFER:
        return (
          <OffersHeroMultiProperty
            modelObj={model}
            offersHeroProps={offersData}
            variation={COBRAND_SINGLE_OFFER}
            getOfferDataFromLightning={getOfferDataFromLightning}
            isLogoFlagEnabled={isLogoFlagEnabled}
          />
        );
      case MULTI_BRAND_MULTI_PROP_OFFER:
        return (
          <OffersHeroMultiProperty
            modelObj={model}
            offersHeroProps={offersData}
            variation={MULTI_BRAND_MULTI_PROP_OFFER}
            getOfferDataFromLightning={getOfferDataFromLightning}
            isLogoFlagEnabled={isLogoFlagEnabled}
          />
        );
      case SINGLE_PROPERTY_OFFER:
        return (
          <OffersHeroSingleProperty
            modelObj={model}
            offersHeroProps={offersData}
            variation={SINGLE_PROPERTY_OFFER}
            getOfferDataFromLightning={getOfferDataFromLightning}
          />
        );
      case ANCILLARY_PRODUCT_OFFER:
        return (
          <OffersHeroSingleProperty
            modelObj={model}
            offersHeroProps={offersData}
            getOfferDataFromLightning={getOfferDataFromLightning}
          />
        );
      default:
        return (
          <OffersHeroSingleProperty
            modelObj={model}
            offersHeroProps={offersData}
            getOfferDataFromLightning={getOfferDataFromLightning}
          />
        );
    }
  };

  return offersData?.isPreview === 'true' ? (
    <StyledOffersHeroPreviewMode data-testid="offers-hero" data-component-name="o-offers-hero">
      <OfferHeroComponent />
    </StyledOffersHeroPreviewMode>
  ) : (
    <StyledOffersHero data-testid="offers-hero" data-component-name="o-offers-hero">
      <OfferHeroComponent />
    </StyledOffersHero>
  );
};

export const OffersHeroWrapperConfig = {
  emptyLabel: 'offersHero',
  isEmpty: false,
  resourceType: `mi-aem-offers-spa/components/offers-hero`,
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const OffersHero = (props: any) => {
  const isNonEditable = props.cqPath?.includes('experiencefragment');
  const offersHeroWrapper = (
    <div className="m-container-fullbleed">
      <OffersHeroReactWrapper {...props} />
    </div>
  );

  return isNonEditable ? (
    offersHeroWrapper
  ) : (
    <EditableComponent config={OffersHeroWrapperConfig} {...props}>
      {offersHeroWrapper}
    </EditableComponent>
  );
};
